import { StarsButton } from '@ps/web-shared-components';
import React from 'react';

import { TXTCLI_Share_link } from './ShareLinkButton.messages.json';
import styles from './ShareLinkButton.scss';

const ShareLinkButton: React.FC<{ url: string }> = ({ url }) => {
  const handleClick = () => navigator.share({ title: document.title, url });

  return (
    <StarsButton
      className={styles.shareLink}
      onClick={handleClick}
      translation={TXTCLI_Share_link}
    />
  );
};

export default ShareLinkButton;
